<template>
  <b-card no-body>
    <b-card-header>
      <slot />
      {{ title }}
    </b-card-header>
    <b-card-body>
      <b-form-row 
        v-for="(g,index) in form.group" 
        :key="index"
      >
        <b-col 
          v-for="(subitem,index) in g.item" 
          v-if="isArray(g.item)" 
          :key="index"
        >
          <b-form-group :label="subitem['#text']">
            <b-input-group 
              v-if="hasEigenschap(subitem['-id'].toUpperCase())" 
              :prepend="subitem['-id']"
            >
              <b-form-input
                v-model="data[subitem['-id'].toUpperCase()]"
                :placeholder="subitem['-id']"
              />
            </b-input-group>
            <b-alert 
              v-else 
              show 
              variant="danger"
            >
              {{ subitem['-id'] }} ontbreekt! 
              <b-button
                size="sm"
                variant="success"
                class="pull-right"
                @click="addEigenschap(subitem['-id']);"
              >
                toevoegen
              </b-button>
            </b-alert>
            <b-form-text>{{ subitem['-suggest'] }}</b-form-text>
          </b-form-group>
        </b-col>
        
        <b-col v-else>
          <b-form-group :label="g.item['#text']">
            <b-form-input
              v-if="hasEigenschap(g.item['-id'])"
              v-model="data[g.item['-id'].toUpperCase()]"
              :placeholder="g.item['-id']"
            />
            <b-alert 
              v-else 
              show 
              variant="danger"
            >
              {{ g.item['-id'] }} ontbreekt!
              <b-button
                size="sm"
                variant="success"
                class="pull-right"
                @click="addEigenschap(g.item['-id']);" 
              >
                toevoegen
              </b-button>
            </b-alert>
          </b-form-group>
        </b-col>
        <b-button 
          v-if="editMode" 
          class="my-3" 
          variant="outline-secondary" 
          @click="g.item.push({ '-id': 'TEST', '#text': 'test' } )"
        >
          +
        </b-button>
      </b-form-row>
      <b-button 
        v-if="editMode" 
        class="my-3" 
        variant="outline-secondary" 
        @click="form.group.push({ 'item': [{ '-id': 'LCA', '#text': 'test' }]})"
      >
        + Nieuwe rij beginnen
      </b-button>
    </b-card-body>
    <b-card-footer>
      <b-button 
        :disabled="isBusy || data == null" 
        variant="success" 
        @click="opslaanInventarisatie(data)"
      >
        Opslaan
      </b-button>
      {{ boodschap }}
    </b-card-footer>
  </b-card>
</template>
<script>
import { elementenMixin } from "@/mixins/elementenMixin";
export default {
  name: "ElementCard",
  mixins: [elementenMixin],
  props: {
    title: { 
      type: String,
      default: null
    },
    form: { 
      type: Object,
      default: () => null
    },
    data: { 
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      isBusy: false,
      boodschap: "...",
      editMode: false
    };
  },
  watch: {
    data: function() {
      if (this.data) this.autoPopulateFields()
    }
  },
  methods: {
    hasEigenschap(code) {
      return this.data[code.toUpperCase()] != null;
    },
    getEigenschap(code) {
      return this.data[code.toUpperCase()];
    },
    addEigenschap(code,waarde) {
      this.$set(this.data,code,waarde || '');
    },
    isArray(obj) {
      return Array.isArray(obj);
    },
    autoPopulateFields() {
      // maak velden aan waar nodig 
      for (var g in this.form.group) {
        for (var row in this.form.group[g]) {
          // console.dir(this.form.group[g][row]);
          for (var field in this.form.group[g][row]) {
            var code = this.form.group[g][row][field]["-id"];
            if (!this.hasEigenschap(code)) this.addEigenschap(code);
          }
        }
      } 
    },
    getEigenschapIndex(code) {
      for (var e in this.data) {
        var c = code ? code.toUpperCase() : "";
        if (this.data[e].Code == c) return e;
      }
    },
    
  }
};
</script>